module.exports = __webpack_public_path__ + "static/media/Step3.07e7369d.svg";